import { render, staticRenderFns } from "./NewsListV3.vue?vue&type=template&id=7f1920f4&scoped=true"
import script from "./NewsListV3.vue?vue&type=script&lang=js"
export * from "./NewsListV3.vue?vue&type=script&lang=js"
import style0 from "./NewsListV3.vue?vue&type=style&index=0&id=7f1920f4&prod&lang=scss&scoped=true"
import style1 from "./NewsListV3.vue?vue&type=style&index=1&id=7f1920f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1920f4",
  null
  
)

export default component.exports